/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedDocGetRozsahAktualizacniZmenyExtentRequest } from '../types/PatchedDocGetRozsahAktualizacniZmenyExtent';
import type { DocGetRozsahAktualizacniZmenyExtentResponse } from '../types/DocGetRozsahAktualizacniZmenyExtent';

export type DocsGetRozsahAktualizacniZmenyExtentPartialUpdateRequest =
  PatchedDocGetRozsahAktualizacniZmenyExtentRequest;
export type DocsGetRozsahAktualizacniZmenyExtentPartialUpdateResponse =
  DocGetRozsahAktualizacniZmenyExtentResponse;

export type DocsGetRozsahAktualizacniZmenyExtentPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/docs/{id}/get_rozsah_aktualizacni_zmeny_extent/
 *
 * ```yaml
 * operationId: docs_get_rozsah_aktualizacni_zmeny_extent_partial_update
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocGetRozsahAktualizacniZmenyExtent'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocGetRozsahAktualizacniZmenyExtent'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocGetRozsahAktualizacniZmenyExtent'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DocGetRozsahAktualizacniZmenyExtent'
 *     description: ''
 * ```
 */
export const docsGetRozsahAktualizacniZmenyExtentPartialUpdateOperation = ({
  id,
  ...rest
}: DocsGetRozsahAktualizacniZmenyExtentPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/docs/${id}/get_rozsah_aktualizacni_zmeny_extent/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/docs/{id}/get_rozsah_aktualizacni_zmeny_extent/' };
  };

/**
 * PATCH /dmx-server/docs/{id}/get_rozsah_aktualizacni_zmeny_extent/
 *
 * ```yaml
 * operationId: docs_get_rozsah_aktualizacni_zmeny_extent_partial_update
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocGetRozsahAktualizacniZmenyExtent'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocGetRozsahAktualizacniZmenyExtent'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocGetRozsahAktualizacniZmenyExtent'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DocGetRozsahAktualizacniZmenyExtent'
 *     description: ''
 * ```
 */
export const docsGetRozsahAktualizacniZmenyExtentPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DocsGetRozsahAktualizacniZmenyExtentPartialUpdateQuery;
  request: PatchedDocGetRozsahAktualizacniZmenyExtentRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DocGetRozsahAktualizacniZmenyExtentResponse>> => {
  const operation = docsGetRozsahAktualizacniZmenyExtentPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
